var PortafoliosDataGrid;
(function (PortafoliosDataGrid) {
    class GridHeight {
        constructor(_containerId, _autoHeight = false, _autoHeightMin = 180, _autoHeightBottomMargin = 12) {
            this.isResizing = false;
            this.clientYStartPoint = -1;
            this.startHeight = -1;
            this.autoHeight = false;
            this.autoHeightMin = 180;
            this.autoHeightBottomMargin = 12;
            this.manualHeight = false;
            this.handle = document.getElementById('h_' + _containerId);
            this.container = document.getElementById(_containerId);
            this.autoHeight = _autoHeight;
            this.autoHeightMin = _autoHeightMin;
            this.autoHeightBottomMargin = _autoHeightBottomMargin;
            if (this.handle) {
                this.containerId = _containerId;
                this.crearEventos();
            }
            if (this.container) {
                this.manualHeight = this.container.getAttribute('data-auto-height-disabled') == 'true';
                var initialHeight = parseFloat(this.container.getAttribute('data-initial-height'));
                this.container.style.height = initialHeight + 'px';
                if (this.autoHeight && !this.manualHeight) {
                    requestAnimationFrame(() => this.setAutoHeight());
                }
            }
        }
        crearEventos() {
            this.mouseDownRef = (e) => this.mouseDown(e);
            this.mouseMoveRef = (e) => this.mouseMove(e);
            this.mouseUpRef = (e) => this.mouseUp(e);
            this.resizeRef = () => this.setAutoHeight();
            this.handle.addEventListener('mousedown', this.mouseDownRef);
            document.addEventListener('mousemove', this.mouseMoveRef);
            document.addEventListener('mouseup', this.mouseUpRef);
            window.addEventListener('resize', this.resizeRef);
        }
        setAutoHeight() {
            if (!this.autoHeight || this.manualHeight || !this.container) {
                return;
            }
            var footer = document.querySelector('.footer');
            var footerHeight = footer && window.getComputedStyle(footer).position == 'fixed'
                ? footer.getBoundingClientRect().height
                : 0;
            var bottomLimit = window.innerHeight - footerHeight - this.autoHeightBottomMargin;
            var gridTop = this.container.getBoundingClientRect().top;
            var followingHeight = this.getFollowingControlsHeight();
            var final = Math.max(this.autoHeightMin, bottomLimit - gridTop - followingHeight);
            this.setHeight(final, this.autoHeightMin);
        }
        getFollowingControlsHeight() {
            var total = 0;
            var next = this.container.nextElementSibling;
            while (next) {
                if (this.shouldIncludeFollowingControl(next)) {
                    total += next.getBoundingClientRect().height;
                }
                next = next.nextElementSibling;
            }
            return total;
        }
        shouldIncludeFollowingControl(element) {
            if (element.classList.contains('grid-context-menu') ||
                element.classList.contains('grid-context-menu-closer')) {
                return false;
            }
            var position = window.getComputedStyle(element).position;
            return position != 'fixed' && position != 'absolute';
        }
        setHeight(height, minHeight = 0) {
            var final = minHeight > 0 ? Math.max(minHeight, height) : height;
            this.container.style.height = final.toFixed(0) + "px";
            this.container.setAttribute('data-initial-height', final.toFixed(0));
        }
        mouseDown(args) {
            args.stopPropagation();
            if (!this.isResizing) {
                this.isResizing = true;
                this.manualHeight = true;
                this.container.setAttribute('data-auto-height-disabled', 'true');
                this.clientYStartPoint = args.clientY;
                this.startHeight = parseFloat(this.container.style.height.replace("px", ""));
                this.handle.classList.add('bg-primary');
                args.preventDefault();
            }
        }
        mouseMove(args) {
            args.stopPropagation();
            if (this.isResizing) {
                var dy = args.clientY - this.clientYStartPoint;
                var final = this.startHeight + dy;
                this.setHeight(final);
                args.preventDefault();
            }
        }
        mouseUp(args) {
            args.stopPropagation();
            if (this.isResizing) {
                this.isResizing = false;
                this.handle.classList.remove('bg-primary');
                args.preventDefault();
            }
        }
        dispose() {
            if (this.handle) {
                this.handle.removeEventListener('mousedown', this.mouseDownRef);
            }
            document.removeEventListener('mousemove', this.mouseMoveRef);
            document.removeEventListener('mouseup', this.mouseUpRef);
            window.removeEventListener('resize', this.resizeRef);
        }
        static crearInstancia(_containerId, _autoHeight = false, _autoHeightMin = 180, _autoHeightBottomMargin = 12) {
            let htmlEl = document.getElementById(_containerId);
            if (!htmlEl) {
                return;
            }
            let found = GridHeight.CurrentInstances.filter(a => a.containerId == _containerId);
            if (found.length > 0) {
                let arrIndex = GridHeight.CurrentInstances.indexOf(found[0]);
                found[0].dispose();
                delete found[0];
                GridHeight.CurrentInstances.splice(arrIndex, 1);
            }
            let newInstance = new GridHeight(_containerId, _autoHeight, _autoHeightMin, _autoHeightBottomMargin);
            GridHeight.CurrentInstances.push(newInstance);
            return newInstance;
        }
    }
    GridHeight.CurrentInstances = [];
    PortafoliosDataGrid.GridHeight = GridHeight;
})(PortafoliosDataGrid || (PortafoliosDataGrid = {}));
